import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../../../../../features/Pagination/Pagination';
import { OptionButton } from '../../../../../utils/Button';
import cn from '../../../../../utils/cn';
import { GetCurrencySymbol } from '../../../../../utils/Currency';
import { TableSortArrow } from '../../../../../utils/IconComp';
import InstOption from '../../../../../utils/InstOption';
import { GetFloatNumber } from '../../../../../utils/NumberFormatter';
import { GetDate } from '../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../utils/URL';

function TableRow({ item }) {
    const navigate = useNavigate();
    // const { setConfirm } = useTemplate();
    const [showMenu, setShowMenu] = useState(false);
    // const { handleReload } = useBillingQuotation();

    const handleShowInstMenu = (e) => {
        e.stopPropagation();
        setShowMenu((d) => !d);
    };

    const handleViewInvoice = () => {
        navigate(mkRelativeUrl(`/billing/invoices/${item?.id}/info`));
    };

    // const handleCancelInvoice = () => {
    //     setConfirm({
    //         showButton: false,
    //         text: <InvoiceCancelModal data={item} handleReload={handleReload} />
    //     });
    // };

    return (
        <tr className={cn(`group `, { 'placeholder-mode': item?.demo })}>
            <td className="!pl-5">
                <span>{item?.quotationNo}</span>
            </td>
            <td
                onClick={() => handleViewInvoice()}
                className="group-hover:text-secondary group-hover:font-medium hover:underline cursor-pointer"
            >
                <span className="cursor-pointer">{item?.invoiceTitle}</span>
            </td>
            <td className="group/item cursor-pointer">
                <span className="group-hover/item:underline group-hover:font-medium group-hover:text-secondary block text-ellipsis overflow-hidden w-full" />
                <Link
                    to={`/agency/${item?.agency?.id || 0}/info`}
                    className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden"
                >
                    {item?.agency?.organization || '-----'}
                </Link>
                <span className="text-sm"> {item?.agency?.email}</span>
            </td>
            <td className="group/item cursor-pointer">
                <span className="group-hover/item:underline group-hover:font-medium group-hover:text-secondary block text-ellipsis overflow-hidden w-full" />
                <Link
                    to={`/agency/${item?.agencyId || 0}/customers/${item?.userId}/info`}
                    className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden"
                >
                    {item?.organization || '-----'}
                </Link>
                <span className="text-sm"> {item?.email}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeIssue)}</span>
            </td>
            <td className="text-center">
                <span>
                    {GetCurrencySymbol(item.currency)}
                    {GetFloatNumber(item?.amountBill)}
                </span>
            </td>
            {/* <td className="text-center">
                <span>
                    {GetCurrencySymbol(item?.currency)}
                    {GetFloatNumber(item?.amountPaid)}
                </span>
            </td> */}

            {/* <td className="text-center">
                <span>{item?.authorizedBy === 0 ? 'No' : 'Yes'}</span>
            </td> */}

            <td className="text-center">
                <span
                    className={cn(`block capitalize whitespace-nowrap text-warning`, {
                        'text-error': item?.status === 'canceled'
                    })}
                >
                    {
                        {
                            paid: 'Pending',
                            due: 'Pending',
                            partial_paid: 'Pending',
                            canceled: 'Canceled',
                            pending: 'Pending'
                        }[item?.status]
                    }
                </span>
            </td>

            <td>
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton onClick={handleShowInstMenu} />

                    <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                        <button type="button" onClick={handleViewInvoice}>
                            View
                        </button>
                        {/* {item?.status === 'due' && (
                            <button type="button" onClick={handleCancelInvoice}>
                                Cancel
                            </button>
                        )} */}
                    </InstOption>
                </div>
            </td>
        </tr>
    );
}
function TableHeader({ sortedColumn, sortBy, onSortedHandler }) {
    return (
        <thead>
            <tr>
                <th onClick={() => onSortedHandler('id')} scope="col" className="!w-36">
                    <span className="uppercase">ID</span>
                    <TableSortArrow name="id" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => onSortedHandler('quotation-title')} scope="col">
                    <span>Quotation Title</span>
                    <TableSortArrow
                        name="quotation-title"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th>
                <th onClick={() => onSortedHandler('agency')} scope="col">
                    <span>Agency</span>
                    <TableSortArrow name="agency" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => onSortedHandler('user')} scope="col">
                    <span>Customer</span>
                    <TableSortArrow name="user" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th
                    onClick={() => onSortedHandler('date-issue')}
                    scope="col"
                    className="w-30 text-center"
                >
                    <span>Issue Date</span>
                    <TableSortArrow name="date-issue" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th
                    onClick={() => onSortedHandler('amount-billed')}
                    scope="col"
                    className="w-32 text-center"
                >
                    <span>Bill Amount</span>
                    <TableSortArrow
                        name="amount-billed"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th>
                {/* <th
                    onClick={() => onSortedHandler('amount-paid')}
                    scope="col"
                    className="w-32 text-center"
                >
                    <span>Paid Amount</span>
                    <TableSortArrow
                        name="amount-paid"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th>
                <th
                    onClick={() => onSortedHandler('is-authorized')}
                    scope="col"
                    className="w-32 text-center"
                >
                    <span>Is Authorized</span>
                    <TableSortArrow
                        name="is-authorized"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th> */}
                <th
                    // onClick={() => onSortedHandler('status')}
                    scope="col"
                    className="w-20 text-center"
                >
                    <span>Status</span>
                    {/* <TableSortArrow name="status" sortedColumn={sortedColumn} sortBy={sortBy} /> */}
                </th>

                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function QuotationListTable({ data, onSortedHandler, onChangePage, sortedColumn, sortBy }) {
    return (
        <div className="billing_quotation_page_table pb-40 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    sortedColumn={sortedColumn}
                    sortBy={sortBy}
                    onSortedHandler={onSortedHandler}
                />

                <tbody>
                    {data?.quotations && data?.quotations?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={8} className="!text-left">
                                No Quotations Found.
                            </td>
                        </tr>
                    ) : (
                        data?.quotations?.map((item) => <TableRow key={item?.id} item={item} />)
                    )}
                </tbody>
            </table>
            <Pagination data={data?.pagination || {}} onChangePage={onChangePage} />
        </div>
    );
}

export default QuotationListTable;
